// extracted by mini-css-extract-plugin
export default {"panel":"panel__6562be07","showPanel":"showPanel__84a5c6f6"};